import { ProfilDTO } from '@/modules/Account/store/state';

export interface MonCompteState {
    isModaleOpen: boolean;
    isLoading: boolean;
    profil: ProfilDTO;

    isPhoneSaving: boolean;
    isMobilePhoneSaving: boolean;
    isMdpSaving: boolean;
    isDeleteAccountRequested: boolean;

}

export const initialState: MonCompteState = {
    isModaleOpen: false,
    isLoading: false,
    profil: {
        nom: '',
        prenom: '',
        adresseMail: '',
        identifiant: '',
        telephonePortable: '',
        telephoneFixe: '',
    },
    isPhoneSaving: false,
    isMobilePhoneSaving: false,
    isMdpSaving: false,
    isDeleteAccountRequested: false

};

export const state: MonCompteState = {
    ...initialState
};
